import {useEffect, useState} from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
    HeaderSection,
    LogoContainer,
    Burger,
    NotHidden,
    Menu,
    CustomNavLinkSmall,
    Label,
    Outline,
    Span,
} from "./styles";
import { useNavigate } from "react-router-dom";

const Header = ({ t }: any) => {
    const navigate = useNavigate();
    const [visible, setVisibility] = useState(false);

    const showDrawer = () => {
        setVisibility(!visible);
    };

    const onClose = () => {
        setVisibility(!visible);
    };

    const MenuItem = () => {
        const [isAuthenticated, setIsAuthenticated] = useState(false);

        useEffect(() => {
            const checkAuthentication = () => {
                const isAuthenticated1 = localStorage.getItem("token") !== null;
                setIsAuthenticated(isAuthenticated1);
            };

            checkAuthentication();
        }, []);

        const scrollTo = (id: string) => {
            const element = document.getElementById(id) as HTMLDivElement;
            element.scrollIntoView({
                behavior: "smooth",
            });
            setVisibility(false);
        };

        const handleClickProblems = () => {
            if (isAuthenticated) {
                navigate("/marketplace/problems");
            } else {
                navigate("/login");
            }
        }

        const handleClickCollaborations = () => {
            if (isAuthenticated) {
                navigate("/marketplace/collaborations");
            } else {
                navigate("/login");
            }
        }
        return (
            <>
                <CustomNavLinkSmall onClick={handleClickProblems}>
                    <Span>{t("Marketplace")}</Span>
                </CustomNavLinkSmall>
                <CustomNavLinkSmall onClick={handleClickCollaborations}>
                    <Span>{t("Collaborations")}</Span>
                </CustomNavLinkSmall>
                <CustomNavLinkSmall
                    style={{ width: "180px" }}
                    onClick={() => navigate("/login")}
                >
                    <Span>
                        <Button>{t("Login")}</Button>
                    </Span>
                </CustomNavLinkSmall>
            </>
        );
    };

    return (
        <HeaderSection>
            <Container>
                <Row justify="space-between">
                    <LogoContainer to="/" aria-label="homepage">
                        <SvgIcon src="logo.svg" width="101px" height="64px" />
                    </LogoContainer>
                    <NotHidden>
                        <MenuItem />
                    </NotHidden>
                    <Burger onClick={showDrawer}>
                        <Outline />
                    </Burger>
                </Row>
                <Drawer closable={false} visible={visible} onClose={onClose}>
                    <Col style={{ marginBottom: "2.5rem" }}>
                        <Label onClick={onClose}>
                            <Col span={12}>
                                <Menu>Menu</Menu>
                            </Col>
                            <Col span={12}>
                                <Outline />
                            </Col>
                        </Label>
                    </Col>
                    <MenuItem />
                </Drawer>
            </Container>
        </HeaderSection>
    );
};

export default withTranslation()(Header);
